/**
 * Elliott voice-conversation rollout flag (Live Simulation step).
 *
 * The two-way spoken simulation (Elliott speaks the scenario and his coaching
 * aloud, the learner replies by voice) is now ON for every org. Browsers
 * without usable speech, and learners who deny the mic, still fall back to the
 * text simulation exactly as before — the voice layer simply never mounts.
 */

/** Set to true to enable the voice simulation for EVERY org. */
export const ELLIOTT_VOICE_ALL_ORGS = true;

/**
 * Orgs with the voice simulation enabled. Both the Mongo _id and the Auth0
 * authId are listed per org, since which one is available depends on how the
 * session was hydrated (same convention as elliottFeatureFlag.ts).
 * (Irrelevant while ELLIOTT_VOICE_ALL_ORGS is true — kept for staged rollback.)
 */
const ENABLED_ORG_IDS = new Set<string>([
  // The Playground (US)
  '6a182725f1b5d4a511343fb3',
  'org_GiHz1oRmIxSq03YX',
  // Nory AI (EU)
  '6a3d2684bd5070082868d6c5',
  'org_ibMIRpDEwdW19gDU'
]);

/**
 * Orgs explicitly OPTED OUT of the voice simulation — they keep the text sim
 * even when ELLIOTT_VOICE_ALL_ORGS is on. This blocklist wins over everything.
 */
const DISABLED_ORG_IDS = new Set<string>([]);

/** Whether the voice simulation is enabled for the given org identifiers (_id / authId). */
export function isElliottVoiceEnabled(...orgIds: Array<string | undefined | null>): boolean {
  if (orgIds.some((id) => Boolean(id && DISABLED_ORG_IDS.has(id)))) return false;
  if (ELLIOTT_VOICE_ALL_ORGS) return true;
  return orgIds.some((id) => Boolean(id && ENABLED_ORG_IDS.has(id)));
}
